import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import {
  listSplitQueue,
  promoteToSplitQueue,
  releaseFromSplitQueue,
} from "../util/splitQueue";

const PLATFORM_ICONS = { desktop: "💻", mobile: "📱" };

// Everything in the Manual Capture Queue — tracked URLs captured by hand in DWW
// Browser instead of by screenhunter — one row per URL and platform, with a way
// to add one and to send one back to the Automatic Capture Queue.
class ManualCaptureQueue extends Component {
  state = {
    jobs: null,
    url: "",
    platform: "both",
    busy: false,
    addError: null,
  };
  mounted = false;

  componentDidMount() {
    this.mounted = true;
    this.refresh();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  safeSetState = update => {
    if (this.mounted) {
      this.setState(update);
    }
  };
  refresh = () =>
    listSplitQueue(this.props.user.token)
      .then(({ jobs }) => this.safeSetState({ jobs: jobs || [] }))
      .catch(err => {
        console.error("Loading the Manual Capture Queue failed", err);
        this.safeSetState({ jobs: this.state.jobs || [] });
      });

  add = e => {
    e.preventDefault();
    const url = this.state.url.trim();
    if (!url) {
      return;
    }
    this.setState({ busy: true, addError: null });
    promoteToSplitQueue(this.props.user.token, url, this.state.platform)
      .then(() => this.safeSetState({ url: "" }))
      // Adding is the one place a reason is worth showing: a URL that isn't
      // tracked, or isn't spelt exactly as it's tracked, can't be queued.
      .catch(err => this.safeSetState({ addError: err.message }))
      .then(this.refresh)
      .then(() => this.safeSetState({ busy: false }));
  };

  remove = job => e => {
    e.preventDefault();
    const question = `Remove ${job.platform} for ${job.url} from the Manual Capture Queue?`;
    if (!window.confirm(question)) {
      return;
    }
    this.setState({ busy: true });
    releaseFromSplitQueue(this.props.user.token, job.url, job.platform)
      .catch(err => console.error(`Removing ${job.url} failed`, err))
      .then(this.refresh)
      .then(() => this.safeSetState({ busy: false }));
  };

  render() {
    const { user } = this.props;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }
    const { jobs, url, platform, busy, addError } = this.state;
    return (
      <div>
        <h1>Manual Capture Queue</h1>
        <form className="flex items-center mb3" onSubmit={this.add}>
          <input
            className="flex-auto mr2"
            type="text"
            placeholder="Tracked URL"
            value={url}
            onChange={e => this.setState({ url: e.target.value })}
            disabled={busy}
          />
          <select
            className="mr2"
            value={platform}
            onChange={e => this.setState({ platform: e.target.value })}
            disabled={busy}
          >
            <option value="both">Desktop and mobile</option>
            <option value="desktop">Desktop</option>
            <option value="mobile">Mobile</option>
          </select>
          <button type="submit" disabled={busy || !url.trim()}>
            Add
          </button>
        </form>
        {addError && <p className="red">{addError}</p>}
        {jobs === null && <p>Loading&hellip;</p>}
        {jobs && jobs.length === 0 && (
          <p className="gray">Nothing is in the Manual Capture Queue.</p>
        )}
        {jobs && jobs.length > 0 && (
          <table className="table">
            <tbody>
              {jobs.map(job => (
                <tr key={`${job.url}~${job.platform}`}>
                  <td>
                    <Link to={`/screens/${encodeURIComponent(job.url)}`}>
                      {job.url}
                    </Link>
                  </td>
                  <td className="ttc">
                    {PLATFORM_ICONS[job.platform]} {job.platform}
                  </td>
                  <td className="tr">
                    <button onClick={this.remove(job)} disabled={busy}>
                      Remove
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  }
}

export default ManualCaptureQueue;
